module.exports = __webpack_public_path__ + "static/media/success(8) (Custom).d5ed39c5.png";